// extracted by mini-css-extract-plugin
export default {"wifiZone":"wifi-zones-map-marker_wifiZone__Rr0ga","wifiZone-center":"wifi-zones-map-marker_wifiZone-center__TuhqE"};